import { IBank } from 'shared/types/banksList';

import { IState } from '../../store';

export function selectRandomBankList({ banksList }: IState): IBank[] {
  return banksList.randomList;
}
